import EventEmitter from 'wolfy87-eventemitter';

export const eventEmitter = new EventEmitter();
